/**
 * Datos del reporte que se generara de las tareas
 *
 * @class DatosReporte
 */
export class DatosReporteTarea {
  fecha_creacion: string;
  fecha_finalizacion: string;
  tarea: string;
  tramite: string;
}

/**
 * Datos del reporte que se generara de los tramites
 *
 * @class DatosReporte
 */
export class DatosReporte {
  fecha_creacion: string;
  fecha_finalizacion: string;
  tramite: number;
}

/**
 * Modelo de un reporte dinamicos
 *
 * @export
 * @class ReporteDinamico
 */
export class ReporteDinamico {
  id: number;
  nombre: string;
  fecha_registro: string;
  tipo_reporte: TipoReporte;
}

/**
 * Modelo del tipo de reporte dinamico
 *
 * @export
 * @class TipoReporte
 */
export class TipoReporte {
  id: number;
  nombre: string;
  descripcion: string;
}

/**
 * Modelo de la consulta de los reportes
 *
 * @export
 * @class Reporte
 */
export class Reporte {
  id?: number;
  nombre: string;
  descripcion: string;
  codigo: string;
  tipo_reporte: number | TipoReporte;
  categoria: number;
  query?: string;
}

/**
 * Modelo de la categoria del reporte
 *
 * @export
 * @class CategoriaReporte
 */
export class CategoriaReporte {
  id?: number;
  nombre: string;
  descripcion: string;
}

/**
 * Modelo de la consulta de reportes por categoria
 *
 * @export
 * @class ReportesCategoria
 * @extends {CategoriaReporte}
 */
export class ReportesCategoria extends CategoriaReporte {
  reportes: Reporte[];
}

/**
 * Modelo de la consulta de los tramites asociados al un reporte
 *
 * @export
 * @class ReporteTramite
 */
export class ReporteTramite {
  id?: number;
  reporte: number;
  tramite: number;
  nombre_tramite: string;
  tareas: any;
}

/**
 * Modelo para el enpoint de asociar un tramite a un reporte
 *
 * @export
 * @class AsociacionReporteTramite
 */
export class AsociacionReporteTramite {
  reporte: number;
  tramite: number;
}

/**
 * Modelo de la columna de una estructura del reporte
 * Cambio en la propiedad operaciones, ahora es opcional
 * @export
 * @class EstructuraReporte
 */
export class EstructuraReporte {
  id?: number;
  celda: string;
  nombre: string;
  orden: number;
  operaciones?: any;
  dato: Partial<ColumnaFuenteDatosEstructura>;
  estatico: boolean;
  tipo_campo: number;
  reporte?: number;
  alias?: string;
  imagen?: any;
}

/**
 * Modelo de una fuente de datos para una columna de la estructura de un reporte
 *
 * @export
 * @class ColumnaFuenteDatosEstructura
 */
export class ColumnaFuenteDatosEstructura {
  id_tarea?: number;
  id_forma?: number;
  campo_interno?: string | string[];
  campo_forma?: string | string[];
  campo_tabla?: string | string[];
  tarea_documento?: string | string[];
}

export class reportCategory {
  nombre: string;
  descripcion: string;
  id: number;
  reportes: Array<Reporte>;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/reporte.model.ts